import React, { Fragment, useContext, useRef, useState } from 'react';
import { userActions } from '../../constants/user-actions';
import AuthContext from '../../context/auth_context';
import { useModalToggle } from '../../hooks/useModalToggle';
import { confirmDialog } from '../Reusable/ConfirmDialog';
import CustomModal from '../Reusable/Modal/CustomModal';
import TableContainer from '../Reusable/Table/TableContainer';
import UserFormContainer from './UserFormContainer';
import { tableConfig } from './userTableConfig';

const UserTable = (props) => {
  const {
      userList,
      rolesHashMapList,
      error,
      createUserHandler,
      updateUser,
      resetUserPassword,
      deleteUserHandler,
      activateUser,
      deactivateUser,
      deactivate2fa,
      activateUser2fa,
      deleteErrorUser,
      deleteErrorSecurity,
      clearGeneratedPassword,
      dispatch,
      t,
      gt,
      page,
      rowsPerPage,
      totalElements,
      setActivePage,
      setPageSize,
      loading,
      loadingPassword,
      generatedUsername,
      generatePassword,
      generatedPassword,
      unlockUser,
    } = props || {},
    { UserTable: UserTableTranslation, Modals, Form } = t || {},
    {
      tableTitle,
      HeaderColumns,
      Tooltips,
      ConfirmDialog,
      NotificationMessages,
    } = UserTableTranslation || {};

  const { allowedActions, loggedUser } = useContext(AuthContext);
  const submitRef = useRef();

  const [showModal, toggleModal, user, toggleUpdate] = useModalToggle(false);
  const [passwordChangeSignal, setPasswordChangeSignal] = useState(false);

  const modalForPasswordChangeShowHandler = (item) => {
    setPasswordChangeSignal(true);
    toggleUpdate(item);
  };

  const modalCloseHandler = () => {
    toggleModal(false);
    setPasswordChangeSignal(false);
    dispatch(deleteErrorUser());
    dispatch(deleteErrorSecurity());
    dispatch(clearGeneratedPassword());
  };

  const confirmActionHandler = (
    id,
    userAction,
    confirmMessage,
    isDispatched = true
  ) => {
    const action = () => {
      isDispatched
        ? dispatch(userAction(id, NotificationMessages))
        : userAction(id, NotificationMessages);
    };
    confirmDialog(confirmMessage, action, '', gt);
  };

  const saveHandler = (userForSave) => {
    if (user) {
      if (passwordChangeSignal) {
        dispatch(
          resetUserPassword(
            userForSave,
            modalCloseHandler,
            NotificationMessages
          )
        );
      } else {
        dispatch(
          updateUser(userForSave, modalCloseHandler, NotificationMessages)
        );
      }
    } else {
      createUserHandler(userForSave, modalCloseHandler, NotificationMessages);
    }
  };

  const passwordGeneratorHandler = (event) => {
    event.preventDefault();
    dispatch(generatePassword(NotificationMessages));
  };

  const tableConfiguration = tableConfig({
    t: Tooltips,
    editAction: (item) => toggleUpdate(item),
    deleteAction: (item) =>
      confirmActionHandler(
        item?.id,
        deleteUserHandler,
        ConfirmDialog.deleteMessage,
        false
      ),
    editPasswordAction: (item) => modalForPasswordChangeShowHandler(item),
    setUserStatusActive: (item) =>
      confirmActionHandler(
        item?.id,
        activateUser,
        ConfirmDialog.activateMessage
      ),
    setUserStatusDeactive: (item) =>
      confirmActionHandler(
        item?.id,
        deactivateUser,
        ConfirmDialog.deactivateMessage
      ),
    setUserStatusDeactivate2fa: (item) =>
      confirmActionHandler(
        item?.id,
        deactivate2fa,
        ConfirmDialog.deactivate2faMessage
      ),
    edit2faRegistrationWhenStatusPassive: (item) =>
      confirmActionHandler(
        item?.id,
        activateUser2fa,
        ConfirmDialog.activateMessage2fa
      ),
    disableDelete: (item) => item?.id === +loggedUser?.id,
    disableActivateDeactivate: (item) => item?.id === +loggedUser?.id,
    allowedActions,
    unlockAction: (item) =>
      confirmActionHandler(item?.id, unlockUser, ConfirmDialog.unlockMessage),
  });

  let modalTitle = '';
  if (user) {
    modalTitle = passwordChangeSignal
      ? Modals.modalForResetPasswordTitle
      : Modals.modalForUpdateTitle;
  } else {
    modalTitle = Modals.modalForAddTitle;
  }

  const isUserCreationAllowed = allowedActions.includes(
    userActions.USER_CREATE
  );

  return (
    <Fragment>
      <TableContainer
        tableId="users"
        renderAction={isUserCreationAllowed}
        action={toggleModal}
        translations={{ tableTitle, Tooltips, HeaderColumns }}
        gt={gt}
        tableConfig={tableConfiguration}
        items={userList}
        page={page}
        rowsPerPage={rowsPerPage}
        totalElements={totalElements}
        setActivePage={setActivePage}
        setPageSize={setPageSize}
        loading={loading}
      />
      {showModal && (
        <CustomModal
          show={showModal}
          hideModal={modalCloseHandler}
          title={modalTitle}
          submitRef={submitRef}
          loading={loading}
        >
          <UserFormContainer
            saveHandler={saveHandler}
            translations={Form}
            error={error}
            userForUpdate={user}
            rolesHashMapList={rolesHashMapList}
            passwordChangeSignal={passwordChangeSignal}
            generatedUsername={generatedUsername}
            generatedPassword={generatedPassword}
            onGeneratePassword={passwordGeneratorHandler}
            submitRef={submitRef}
            loadingPassword={loadingPassword}
          />
        </CustomModal>
      )}
    </Fragment>
  );
};

export default UserTable;
